import * as ko from "knockout";

import { addBindingHandler } from "./util";


/**
 * Binding to stop the prapagation of other bindings.
 */
export interface StopBinding {
    init: () => void;
}


const stopBinding = {
    init: () => {
        return { controlsDescendantBindings: true };
    }
};


/**
 * Activates the 'stopBinding' binding.
 */
export function activateStopBinding(): StopBinding {
    const handler = addBindingHandler("stopBinding", stopBinding);

    if (!ko.virtualElements.allowedBindings["stopBinding"]) {
        // Make stopBinding applicable to virtual elements also
        // (see http://www.knockmeout.net/2012/05/quick-tip-skip-binding.html)
        ko.virtualElements.allowedBindings["stopBinding"] = true;
    }

    return handler;
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/stopBinding.ts